module.exports = __webpack_public_path__ + "media/assets/faria_products/info_icon-f688dfaa410ec98db937094e1210699fb94ab8a8681082222896139d17f46f1e.svg";